<template>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <c-table
        ref="table"
        title="체크리스트 목록"
        :columns="grid.columns"
        :gridHeight="gridHeight"
        :data="tabParam.ctoChecklistModels"
        :editable="editable&&!disabled"
        :filtering="false"
        :isExcelDown="false"
        :columnSetting="false"
        :usePaging="false"
        noDataLabel="체크리스트를 추가하세요."
        selection="multiple"
        rowKey="sopCtoChecklistId"
        @changeSelection="changeSelection"
      >
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn
              v-if="editable && !disabled"
              label="추가"
              icon="add"
              @btnClicked="addChecklist"
            />
            <c-btn
              v-if="editable && !disabled && tabParam.ctoChecklistModels.length > 0"
              label="삭제"
              icon="delete"
              @btnClicked="deleteChecklist"
            />
            <c-btn
              v-if="editable && !disabled && tabParam.ctoChecklistModels.length > 0"
              :url="saveUrl"
              :isSubmit="isSave"
              :param="tabParam.ctoChecklistModels"
              mappingType="POST"
              label="저장"
              icon="save"
              @beforeAction="saveChecklist"
              @btnCallback="saveCallback" 
            />
          </q-btn-group>
        </template>
        <template v-slot:customArea="{ props, col }">
          <template v-if="props.row['sopImprovementIds'] && props.row['ibmStepNames'] && col.name === 'customCol'">
            <q-chip
              v-for="(item, index) in $comm.ibmTagItems(props.row)"
              :key="index"
              :color="item.color"
              :clickable="true"
              text-color="white"
              style="margin-bottom:4px !important;"
              @click="linkClick(item, props.row)">
              {{item.title}}
              <c-assess-tooltip 
                :ibmTooltip="item.ibmTooltip"
                :ibmClassCd="item.ibmClassCd"
              />
            </q-chip>
          </template>
          <div v-if="props.row.editFlag!=='C'">
            <q-btn-group outline class="ColumInnerBtnGroup">
              <q-btn
                v-if="editable&&!disabled"
                icon="add"
                color="red-6"
                text-color="white"
                class="ColumInnerBtn"
                align="center"
                @click.prevent="innerBtnClicked(col, props, '1')">
                <q-tooltip>
                  개선요청등록
                </q-tooltip>
              </q-btn>
              <q-btn
                v-if="editable&&!disabled"
                icon="add"
                color="light-blue"
                text-color="white"
                class="ColumInnerBtn"
                align="center"
                @click.prevent="innerBtnClicked(col, props, '2')">
                <q-tooltip>
                  즉시조치등록
                </q-tooltip>
              </q-btn>
            </q-btn-group>
          </div>
        </template>
      </c-table>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'cto-checklist',
  props: {
    tabParam: {
      type: Object,
      default: () => ({
        sopCtoId: '',
        ctoCompleteFlag: '',
        ctoChecklistModels: [],
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      editable: true,
      grid: {
        columns: [],
        data: [],
        height: '760px'
      },
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      saveUrl: '',
      deleteUrl: '',
      saveType: 'POST',
      isSave: false,
      title: '',
      comboItems: [],
    };
  },
  computed: {
    disabled() {
      return this.editable && Boolean(this.tabParam.ctoCompleteFlag) && this.tabParam.ctoCompleteFlag === 'Y'
    },
    gridHeight() {
      return String(this.contentHeight - 100) + 'px';
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
    this.init();
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      // code setting
      this.saveUrl = transactionConfig.sop.cto.checklist.save.url;
      this.deleteUrl = transactionConfig.sop.cto.checklist.delete.url;
      // list setting
      this.setHeader();
    },
    setHeader() {
      this.$comm.getComboItems('CTO_GOOD_BAD_CD').then(_result => {
        this.grid.columns = [
          {
            name: 'checklistName',
            field: 'checklistName',
            label: '체크리스트 항목',
            align: 'left',
            style: 'width:400px',
            sortable: false,
          },
          // {
          //   name: 'selectValue',
          //   field: 'selectValue',
          //   label: '양호/불량/해당없음',
          //   type: 'select',
          //   setHeader: true,
          //   style: 'width:200px',
          //   align: 'center',
          //   comboItems: _item,
          //   sortable: false,
          // },
          {
            name: "selectValue",
            field: "selectValue",
            label: "양호/불량/해당없음",
            style: 'width:100px',
            type: 'select',
            align: "center",
            setHeader: true,
            comboItems: _result,
            sortable: false,
          },
          {
            name: 'remarks',
            field: 'remarks',
            label: '비고',
            type: 'text',
            style: 'width:500px',
            align: 'left',
            sortable: false
          },
          {
            name: 'customCol',
            field: 'customCol',
            label: '개선번호/개선진행상태',
            align: 'center',
            style: 'width:120px',
            type: 'custom',
            sortable: false
          },
        ]
      })
    },
    /* eslint-disable no-unused-vars */ 
    innerBtnClicked(col, props, btn) {
      this.requestImprRow = props.row
      let requestContents = props.row.checklistName;
      if (btn === '1') {
        this.popupOptions.title = '개선 요청';
        this.popupOptions.param = {
          requestContents: requestContents,
          relationTableKey: props.row.sopCtoChecklistId,
          ibmTaskTypeCd: 'ITT0000060',
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprRequest.vue'}`);
        this.popupOptions.width = '90%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeAddImprPopup;
      } else {
        this.popupOptions.title = '즉시조치';
        this.popupOptions.param = {
          requestContents: requestContents,
          relationTableKey: props.row.sopCtoChecklistId,
          ibmTaskTypeCd: 'ITT0000060',
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmediate.vue'}`);
        this.popupOptions.width = '90%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeAddImprPopup;
      }
    },
    closeAddImprPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.$_.forEach(data, item => {
        let sData = this.requestImprRow.sopImprovementIds ? this.requestImprRow.sopImprovementIds : '';
        if (sData.indexOf(item.sopImprovementId) === -1) {
          this.requestImprRow.sopImprovementIds = this.requestImprRow.sopImprovementIds ? 
            this.requestImprRow.sopImprovementIds + ',' + item.sopImprovementId : item.sopImprovementId
          this.requestImprRow.ibmStepNames = this.requestImprRow.ibmStepNames ? 
            this.requestImprRow.ibmStepNames + ',' + item.ibmStepName : item.ibmStepName
          this.requestImprRow.ibmClassCds = this.requestImprRow.ibmClassCds ? 
            this.requestImprRow.ibmClassCds + ',' + item.ibmClassCd : item.ibmClassCd
          this.requestImprRow.ibmTooltip = this.requestImprRow.ibmTooltip ? 
            this.requestImprRow.ibmTooltip + ',' + item.ibmTooltip : item.ibmTooltip
        }
      })
      if (data && data.length > 0) {
        this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
      }
    },
    linkClick(data, row) {
      this.requestImprRow = row
      this.imprData = data;

      if (data.ibmClassCd === 'IC00000001') {
        this.popupOptions.title = '개선';
        this.popupOptions.param = {
          sopImprovementId: data.sopImprovementId,
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprDetail.vue'}`);
        this.popupOptions.width = '90%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeImprPopup;
      } else {
        this.popupOptions.title = '즉시조치';
        this.popupOptions.param = {
          sopImprovementId: data.sopImprovementId,
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmDetail.vue'}`);
        this.popupOptions.width = '90%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeImprPopup;
      }
    },
    closeImprPopup(result, flag) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.$emit('getDetail')
      this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
    },
    changeSelection(detail) {
      if (detail.added) {
        let pushItems = [];
        this.$_.forEach(detail.rows, row => {
          // 부모가 추가된 경우
          if (row.parentChecklistMasterId === '0000000000') {
            pushItems = this.$_.concat(pushItems, this.$_.filter(this.tabParam.ctoChecklistModels, filterItem => {
              return filterItem.parentChecklistMasterId === row.checklistMasterId
                && this.$_.findIndex(this.$refs['table'].selected, { checklistMasterId: filterItem.checklistMasterId }) === -1
            }))
          }
        })
        setTimeout(() => {
          this.$refs['table'].selected = this.$_.concat(this.$refs['table'].selected, pushItems)
        }, 100);
      } else {
        this.$_.forEach(detail.rows, row => {
          // 부모가 해제된 경우
          if (row.parentChecklistMasterId === '0000000000') {
            let childItems = this.$_.filter(this.tabParam.ctoChecklistModels, filterItem => {
              return filterItem.parentChecklistMasterId === row.checklistMasterId
                && this.$_.findIndex(this.$refs['table'].selected, { checklistMasterId: filterItem.checklistMasterId }) > -1
            })
            this.$_.forEach(childItems, item => {
              this.$refs['table'].selected.splice(
                this.$_.findIndex(this.$refs['table'].selected, { checklistMasterId: item.checklistMasterId }),
                1
              )
            })
          }
        })
      }
    },
    addChecklist() {
      this.popupOptions.title = '체크리스트 항목';
      this.popupOptions.param = {
        plantCd: this.tabParam.plantCd
      };
      this.popupOptions.target = () => import(`${'./ctoChecklistMasterPop.vue'}`);
      this.popupOptions.width = '40%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeItmePopup;
    },
    closeItmePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        let addItems = [];
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.tabParam.ctoChecklistModels, { checklistMasterId: item.checklistMasterId }) === -1) {
            item.editFlag = 'C'
            item.regUserId = this.$store.getters.user.userId
            item.sopCtoId = this.tabParam.sopCtoId
            item.selectValue = 'CGB0000003'
            addItems.push(item)
          }
        })
        this.$http.url = this.saveUrl;
        this.$http.type = 'POST';
        this.$http.param = addItems
        this.$http.request(() => {
          window.getApp.$emit('APP_REQUEST_SUCCESS');
          this.$emit('getDetail')
        },);
        this.saveChecklist();
      }
    },
    deleteChecklist() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '삭제하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.deleteUrl;
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData),
            };
            this.$http.request(() => {
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              
              this.$_.forEach(selectData, item => {
                this.tabParam.ctoChecklistModels = this.$_.reject(this.tabParam.ctoChecklistModels, item);
              })
              this.$refs['table'].$refs['compo-table'].clearSelection();
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    saveChecklist() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '저장하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$_.forEach(this.tabParam.ctoChecklistModels, item => {
            item.regUserId = this.$store.getters.user.userId
            item.chgUserId = this.$store.getters.user.userId
            item.sopCtoId = this.tabParam.sopCtoId
          })
          this.isSave = !this.isSave;
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('getDetail')
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
    datachange(props) {
      if (props.row['editFlag'] !== 'C') {
        props.row['editFlag'] = 'U'
        props.row['chgUserId'] = this.$store.getters.user.userId
      }
    },
  }
};
</script>
